import { render, staticRenderFns } from "./alteraSenha.vue?vue&type=template&id=cb21d3d6&"
import script from "./alteraSenha.vue?vue&type=script&lang=js&"
export * from "./alteraSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports